<template>
  <div class="right-panel">
    <el-collapse v-model="activeName">
      <el-collapse-item :title="$t(`nav.pMenu.mask`)" name="1">
        <div
          @click="goToProductPage('detail1')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail1'),
          }"
        >
          {{ $t(`nav.pMenu.mask1`) }}
        </div>
        <div
          @click="goToProductPage('detail2')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail2'),
          }"
        >
          {{ $t(`nav.pMenu.mask2`) }}
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t(`nav.pMenu.elastic`)" name="2">
        <div
          @click="goToProductPage('detail3')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail3'),
          }"
        >
          {{ $t(`nav.pMenu.elastic1`) }}
        </div>
        <div
          @click="goToProductPage('detail4')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail4'),
          }"
        >
          {{ $t(`nav.pMenu.elastic2`) }}
        </div>
        <div
          @click="goToProductPage('detail5')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail5'),
          }"
        >
          {{ $t(`nav.pMenu.elastic3`) }}
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t(`nav.pMenu.essence`)" name="3">
        <div
          @click="goToProductPage('detail6')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail6'),
          }"
        >
          {{ $t(`nav.pMenu.essence1`) }}
        </div>
        <div
          @click="goToProductPage('detail7')"
          class="detail-item flex-rowl"
          :class="{
            'detail-item': true,
            'flex-rowl': true,
            active: isActive('detail7'),
          }"
        >
          {{ $t(`nav.pMenu.essence2`) }}
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
  
  <script>
export default {
  name: "ProductCategoryPanel",
  data() {
    return {
      activeName: this.getActiveNameByRoute(),
    };
  },
  computed: {
    isActive() {
      return (productName) => {
        return this.$route.path === `/ProductDetailPage/${productName}`;
      };
    },
  },
  created() {
    this.activeName = this.getActiveNameByRoute();
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.activeName = this.getActiveNameByRoute();
      },
    },
  },
  methods: {
    goToProductPage(productName) {
      let routePath = "";
      switch (productName) {
        case "detail1":
          routePath = "/ProductDetailPage/detail1";
          break;
        case "detail2":
          routePath = "/ProductDetailPage/detail2";
          break;
        case "detail3":
          routePath = "/ProductDetailPage/detail3";
          break;
        case "detail4":
          routePath = "/ProductDetailPage/detail4";
          break;
        case "detail5":
          routePath = "/ProductDetailPage/detail5";
          break;
        case "detail6":
          routePath = "/ProductDetailPage/detail6";
          break;
        case "detail7":
          routePath = "/ProductDetailPage/detail7";
          break;
        default:
          break;
      }
      if (routePath) {
        this.$router.push(routePath);
      }
    },

    getActiveNameByRoute() {
      const path = this.$route.path;
      if (path.includes("detail1") || path.includes("detail2")) {
        return "1";
      } else if (
        path.includes("detail3") ||
        path.includes("detail4") ||
        path.includes("detail5")
      ) {
        return "2";
      } else if (path.includes("detail6") || path.includes("detail7")) {
        return "3";
      }
      return "1"; // 默认展开第一个分类
    },
  },
};
</script>
  
  <style scoped lang="less">
.right-panel {
  flex-shrink: 0;
  width: 268px;
  /deep/.el-collapse-item__header {
    height: 70px;
    font-size: 16px;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    background: #efefef;
    font-weight: 600;
    font-family: "SourceHanSerifCN-Medium", sans-serif;
   
  }
  /deep/.el-collapse-item {
    border-bottom: 1px solid #fff;
  }
  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }
  .detail-item {
    height: 70px;
    background: #EFEFEF;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 16px;
    color: #666666;
    position: relative;
    cursor: pointer;
    &.active {
      background: #ffffff;
      &::before {
        display: inline-block;
        content: "";
        width: 10px;
        height: 70px;
        background: #333333;
        border-radius: 0px 0px 0px 0px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
}
</style>